export default __webpack_public_path__ + "static/media/classes-ico.03651fcd.svg";